import React from "react";
import { ProductTile } from "@lululemon/ui-library";
import { useCategories } from "../../hooks/useCategories";
import styles from "./categories.module.scss";

const Categories = () => {
  const { title, dataSet } = useCategories();
  return (
    <div className="categories wrapper container-fluid">
      <h1 className={`h1 ${styles.title}`}>{title}</h1>
      <div className={styles.layout}>
        {dataSet.map((data) => (
          <ProductTile
            key={`${data.name}`}
            href={data.url}
            imageProps={{
              src: data.imageUrl,
            }}
            name={data.name}
          />
        ))}
      </div>
    </div>
  );
};

export default Categories;
